var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apiHelper } from "@/Common/api/apiHelper";
import { FailActionResult, SuccessActionResult } from "@common/api/actionResult";
import axios from 'axios';
var MachineRegistrationCreationService = /** @class */ (function () {
    function MachineRegistrationCreationService() {
    }
    MachineRegistrationCreationService.prototype.getMachineInformation = function (serialNumber) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var url, response, machineInfo, error_1, errorModel;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = apiHelper.createUrl('MachineRegistrationCreation/MachineInformation', serialNumber);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get(url)];
                    case 2:
                        response = _b.sent();
                        machineInfo = response.data;
                        return [2 /*return*/, new SuccessActionResult(machineInfo)];
                    case 3:
                        error_1 = _b.sent();
                        errorModel = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data;
                        return [2 /*return*/, new FailActionResult(errorModel)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MachineRegistrationCreationService.prototype.createRegistration = function (model) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var formData, url, error_2, errorModel;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('model', JSON.stringify(model));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        url = apiHelper.createUrl('MachineRegistrationCreation/Create');
                        return [4 /*yield*/, axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, new SuccessActionResult(true)];
                    case 3:
                        error_2 = _b.sent();
                        errorModel = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data;
                        return [2 /*return*/, new FailActionResult(errorModel)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MachineRegistrationCreationService.prototype.AddAttachment = function (model) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var formData, formModel, i, file, url, result, error_3, errorModel;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formData = new FormData();
                        formModel = { machineRegistration: model.machineRegistrationData, nonce: model.nonce };
                        formData.append('model', JSON.stringify(formModel));
                        for (i = 0; i < model.attachments.length; i++) {
                            file = model.attachments[i];
                            formData.append('attachments', file);
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        url = apiHelper.createUrl('MachineRegistrationCreation/AddAttachment');
                        return [4 /*yield*/, axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, new SuccessActionResult(result.data)];
                    case 3:
                        error_3 = _b.sent();
                        errorModel = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data;
                        return [2 /*return*/, new FailActionResult(errorModel)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MachineRegistrationCreationService.prototype.validateMachineRegistartion = function (model) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var formData, formModel, url, result, error_4, errorModel;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formData = new FormData();
                        formModel = { registrationData: model.registrationData, machineRegistration: model.machineRegistrationData, nonce: model.nonce };
                        formData.append('model', JSON.stringify(formModel));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        url = apiHelper.createUrl('MachineRegistrationCreation/ValidateMachineRegistration');
                        return [4 /*yield*/, axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, new SuccessActionResult(result.data)];
                    case 3:
                        error_4 = _b.sent();
                        errorModel = (_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.data;
                        return [2 /*return*/, new FailActionResult(errorModel)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return MachineRegistrationCreationService;
}());
export { MachineRegistrationCreationService };
export default new MachineRegistrationCreationService();
